import PropTypes from 'prop-types';
import {LazyMotion, domMax} from 'framer-motion';

// ----------------------------------------------------------------------

export function MotionLazy({children}) {
  return (
    <LazyMotion strict features={domMax}>
      {children}
    </LazyMotion>
  );
}

MotionLazy.propTypes = {
  children: PropTypes.node,
};
